export default "__VITE_ASSET__d82959f7__"